<template>
    <div
      class="modal fade"
      id="referenciaModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Referencia de Factura</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="current" class="modal-body">
            <div class="col-12">
            <input
            type="text"
            v-on:keyup.enter="referenciarFactura()"
            class="form-control"
            v-model="current.referencia"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="referenciarFactura()"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  data() {
    return {};
  },
  props: ["current"],
  computed: {},
  mounted() {},
  methods: {
    referenciarFactura() {
      let self = this;
      self.current.fecha_revision = "";
      DynamicService.postAction(
        "wms",
        "facturas",
        this.current.id,
        "agregar_referencia",
        this.current
      )
        .then((res) => {
          $("#referenciaModal").modal("hide");
          Notifications.alert.success(
            "Referenciar Factura",
            "Realizado correctamente"
          );
        })
        .catch((error) => {
          Notifications.alert.error(
            "Referenciar Factura",
            error.response.data.detail
          );
        });
    },
  },
};
</script>
